"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _withThemeProps = _interopRequireDefault(require("../withThemeProps"));

var themeSettings = {
  name: 'SxSectionHeadline'
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      flex: 'auto',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(1),
      width: '100%',
      height: theme.spacing(8)
    }
  };
}, themeSettings);
/**
 * Nadpis sekce
 */

var SectionHeadline = function SectionHeadline(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      title = _ref.title,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className", "title"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement(_Typography.default, (0, _extends2.default)({
    className: (0, _clsx.default)(classes.root, className),
    variant: "h4",
    noWrap: true,
    component: "div"
  }, rest), title || children);
};

process.env.NODE_ENV !== "production" ? SectionHeadline.propTypes = {
  /**
     * Zobrazovany text
     *
     * @deprecated
     */
  title: _propTypes.default.node
} : void 0;
SectionHeadline.displayName = 'SectionHeadline';

var _default = (0, _withThemeProps.default)(themeSettings)(SectionHeadline);

exports.default = _default;